module.exports = __webpack_public_path__ + "media/images/weather/450_night-0fb70e4524ac7ed4a5cb975fc334919b.png";